import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setMasterData } from 'src/actions/inquiryActions';
import Loader from 'src/components/common/Loader';

const withInquiryMasterData = (Component) => {
  // tslint:disable-next-line: max-line-length
  return connect(mapStateToProps,
    mapDispatchToProps)(class InitInquiryMaster extends React.Component<any, any> {

      state: any = {
        isLoading: true,
      };

      // conpone
      async componentDidMount() {
        if (!this.props.masterData) {
          await this.props.setMasterData();
        }
        this.setState({
          isLoading: false,
        });

      }

      render() {
        const { isLoading } = this.state;
        if (isLoading) {
          return <Loader />;
        }
        return (
          <Component {...this.props} />
        );
      }
    });
};
const mapStateToProps = ({ inquiryReducer }, ownProps) => ({
  masterData: inquiryReducer.masterData,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  setMasterData,
}, dispatch));

export default withInquiryMasterData;
